// @flow

import React from 'react';
import get from 'lodash/get';
import isValid from 'date-fns/is_valid';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import spanishLocale from 'date-fns/locale/es';
import englishLocale from 'date-fns/locale/en';

type Props = {
  formatString: string,
  date?: string | Date,
  commonTranslations?: Object,
  locale?: string,
};

const defaultProps = {
  date: null,
  commonTranslations: {},
  locale: 'en-US',
};

const DateFormat = ({ date, formatString, commonTranslations, locale }: Props) => {
  const dateFnsLocale = locale === 'en-US' ? englishLocale : spanishLocale;
  const actualFormatString = locale === 'en-US' ? formatString : 'D [de] MMMM [de] YYYY';

  const dateString =
    date && isValid(parse(date))
      ? format(date, actualFormatString, { locale: dateFnsLocale })
      : get(commonTranslations, 'notApplicable', 'N/A');
  return <span style={{ display: 'inline-block' }}>{dateString}</span>;
};

DateFormat.defaultProps = defaultProps;

export default DateFormat;
